import React from "react";

const MsjBox = (props) => {
  const titulo = props.titulo;
  const msj = props.msj;
  return (
    <div className="row">
      <div className="col-12">
        <div className="card border-0 mt-3 mb-3">
          <div className="card-body">
            <h5 className="card-title">{titulo}</h5>
            <p className="card-text" style={{ whiteSpace: "pre-line" }}>
              {msj}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MsjBox;
